import { theme } from '@global-engineering-shared/gweb-material-theme-next';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  list: {
    padding: theme.spacing(2, 0, 2, 1),
  },
  listItem: {
    padding: 0,
  },
  button: {
    paddingBottom: theme.spacing(2),
  },
  text: {
    paddingBottom: theme.spacing(2),
  },
}));

export default useStyles;
